import SmoothScroll from 'smooth-scroll';
//import Rellax from 'rellax';
import { transformHeaderOnScroll, toggleMobileMenu } from "./header.js"
import { joinRadio } from "./join.js"
import Plyr from 'plyr';

//Init Rellax
//new Rellax('.rellax');

//Init SmoothScroll
new SmoothScroll('a[href*="#"], a.scroll, li.scroll', {
    //header: '[data-scroll-header]'
});

const header = document.querySelector("header");
const threshold = 40;
const menuTrigger = document.querySelector('.hamburger');

//Init Header Scroll Animation Event
if (header && threshold) window.addEventListener('scroll', function () { transformHeaderOnScroll(header, threshold); } );

//Init Mobile Menu Event
if (menuTrigger && header) menuTrigger.addEventListener('click', function () { toggleMobileMenu(header, menuTrigger); });
joinRadio();

//Closes mobile menu when link with class scroll is clicked
if (document.querySelectorAll('.scroll')) {
    const scrollNav = document.querySelectorAll('.scroll a');
    scrollNav.forEach(function (nav) {
        nav.addEventListener("click", () => { 

            //If child submenu is active remove active class
            if (document.querySelectorAll('.menu-item-has-children.active')) {
                document.querySelectorAll('.menu-item-has-children.active').forEach(function (dropDown) {
                    dropDown.classList.remove('active');
                });
            }
            //If mobile menu is active toggle activeMenu and isActive classes
            if (header.classList.contains('activeMenu')) {
                header.classList.toggle('activeMenu');
                menuTrigger.classList.toggle('isActive');
            }
        });
    });
}

// Sub Menu for Mobile
let plusIcon = '<span class="dropIcon"><i class="fa fa-plus" aria-hidden="true"></i><i class="fa fa-minus" aria-hidden="true"></i></span>'

document.querySelectorAll('.menu-item-has-children a').forEach(function (menu) {
    if (menu.parentElement.classList.contains('menu-item-has-children')) {
        menu.insertAdjacentHTML('beforebegin', plusIcon);
    }
});

document.querySelectorAll('.dropIcon').forEach(function (icon) {
    icon.addEventListener("click", () => {
        if (icon.parentElement.classList.contains('active')) {
            icon.parentElement.classList.remove('active');
        } else {
            icon.parentElement.classList.add('active');
        }
    });
});

//global video player plugin
const plyrOptions = {
	clickToPlay: true,
	controls: ['play-large'],
	youtube: {
		noCookie: false
	},
	fullscreen: {
		enabled: true,
		fallback: true,
		iosNative: true
	}
};

window.addEventListener('DOMContentLoaded', () => {
	const players = Array.from(document.querySelectorAll('.js-player')).map((p) => new Plyr(p, {
		...plyrOptions,
		poster: p.dataset.plyrPoster,
	}));
	players.forEach((player) => {
		player.on('ended', function () {
			player.stop();
		});
	});

	document.querySelectorAll('[data-gi-video-modal]').forEach((trigger) => {
		const modalId = trigger.dataset.giVideoModal;
		const modal = document.getElementById(modalId);

		if (!modal) {
			return;
		}

		const playerEl = modal.querySelector('.js-player-modal');
		let modalPlayer = null;

		const openModal = () => {
			modal.classList.add('is-open');
			modal.setAttribute('aria-hidden', 'false');
			document.body.classList.add('gi-video-modal-open');

			if (playerEl && !modalPlayer) {
				modalPlayer = new Plyr(playerEl, plyrOptions);
				modalPlayer.on('ended', () => modalPlayer.stop());
			}

			if (modalPlayer) {
				modalPlayer.play();
			}
		};

		const closeModal = () => {
			modal.classList.remove('is-open');
			modal.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('gi-video-modal-open');

			if (modalPlayer) {
				modalPlayer.pause();
			}
		};

		trigger.addEventListener('click', (event) => {
			event.preventDefault();
			openModal();
		});

		modal.querySelectorAll('[data-gi-video-modal-close]').forEach((closeTrigger) => {
			closeTrigger.addEventListener('click', closeModal);
		});

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && modal.classList.contains('is-open')) {
				closeModal();
			}
		});
	});
});